import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import swal from 'sweetalert2';
import { CommonService } from '../../../services/index';

@Component({
    selector: 'add-dsr-file-window',
    templateUrl: './addDsrFile.component.html'
})
export class AddDsrFileComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef;
    @Output() fileAddedEvent = new EventEmitter();

    folderList: string[] = ['dsr_daily', 'Retrial fold', 'branch_target', 'Others'];
    selectedFolder: string = '';
    fileName: string = '';
    fileObj: File = null;
    isLoading: boolean = false;

    constructor(public bsModalRef: BsModalRef, private commonService: CommonService) { }

    ngOnInit(): void { }

    triggerFileInput(): void {
        this.fileInput.nativeElement.value = '';
        this.fileInput.nativeElement.click();
    }

    onFileSelected(event: any): void {
        const f = event.target.files[0];
        if (f) {
            this.fileObj = f;
            this.fileName = f.name;
        }
    }

    onUpload(): void {
        if (!this.selectedFolder || !this.fileObj) { return; }
        this.isLoading = true;
        let that = this;
        const formData = new FormData();
        formData.append('file', this.fileObj);
        formData.append('folder', this.selectedFolder);
        this.commonService.uploadAddDsrInputFile(formData)
            .then(function(res: any) {
                that.isLoading = false;
                if (res && res.success) {
                    swal('SUCCESS', res.message || 'File added successfully', 'success');
                    that.bsModalRef.hide();
                    that.fileAddedEvent.emit();
                } else {
                    swal('ERROR', res && res.message ? res.message : 'Failed to add file', 'error');
                }
            })
            .catch(function() {
                that.isLoading = false;
                swal('ERROR', 'Failed to add file', 'error');
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/dsrInputFiles/addDsrFile.component.ts